export default "__VITE_ASSET__64353332__"